module.exports = __webpack_public_path__ + "static/media/Bluelab-Replacement-Medium-Pump-and-Cassette-100-ml-suitable_PUMPCONT-M_1.be035a45.webp";